import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type ApprovalProcessResponse = {
   processid: number;
   name: string;
};

export async function getApprovalProcess(
   processid: number,
   { ...common }: CommonRequestOptions = {}
): Promise<ApprovalProcessResponse> {
   return makeRequest('get', `/approvals/process/${processid}/blurb`, {
      ...common,
   });
}
